import { render } from "./NewProfile.vue?vue&type=template&id=fe79420a&ts=true"
import script from "./NewProfile.vue?vue&type=script&lang=ts"
export * from "./NewProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__